import { Component, OnInit } from '@angular/core';
import { TelecomService } from 'src/app/services/telecom/telecom.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-agent-voicemail',
  templateUrl: './agent-voicemail.component.html',
  styleUrls: ['./agent-voicemail.component.css']
})
export class AgentVoicemailComponent implements OnInit {

  lambdaError: boolean = false;
  lambdaMessage: string = '';
  itemToSave = null;
  newRow: boolean = false;
  data = { "voicemails":[]}
  formValid: boolean = false;

  constructor(private telecomService:TelecomService) { }

  ngOnInit(): void {
    this.getVoicemails();
  }
  
  getVoicemails() {
    this.telecomService.getRows(environment.voicemailLambdaName).then((data: any) => {
      if (data.statusCode == 200) {
        this.lambdaError = false;
        this.lambdaMessage = '';
        this.data.voicemails = data.body.voicemails.Items;
      }
      else {
        this.lambdaError = true;
        this.lambdaMessage = data.Error.message;
        console.log(data.Error)
      }
    });
  }

  updateItem($event) {
    this.itemToSave = $event;
    this.itemToSave['transcribeVoicemail'] = true;
    this.telecomService.saveRow(this.itemToSave, environment.voicemailLambdaName).then((data: any) => {
      if (data.statusCode == 200) {
        this.lambdaError = false;
        if (this.itemToSave.action == "put") {
          this.lambdaMessage = "Data saved successfully.";
        }
        else if (this.itemToSave.action == "delete") {
          this.lambdaMessage = "Data deleted successfully.";
        }
      }
      else {
        this.lambdaError = true;
        this.lambdaMessage = data.Error.message;
        console.log(data.Error);
        if (this.itemToSave.action == "put") {
          this.lambdaMessage = "An error occurred, data was not saved successfully.";
        }
        else if (this.itemToSave.action == "delete") {
          this.lambdaMessage = "An error occurred, data was not deleted successfully.";
        }
      }
    });
  }

  updateMode(gridAction: string) {
    if (gridAction == 'add') {
      this.newRow = true;
    } else if (gridAction == 'edit') {
      this.newRow = false;
    }
  }

  validate(item) {
    this.formValid = false;
    this.lambdaMessage = '';
    this.lambdaError = false;

    let dnisPattern = RegExp("^[0-9]{3}\\-[0-9]{3}\\-[0-9]{4}$");
    //let namePattern = RegExp("^([a-zA-Z0-9_\\-\\.]+)@([a-zA-Z0-9_\\-\\.]+)\\.([a-zA-Z]{2,5})$");
    //let voicemailPattern = RegExp("^[\\+]?[0-9]{11}$");
    if (item.DNIS == null || item.DNIS == "") {
      this.lambdaError = true;
      this.lambdaMessage = 'missing DNIS'
      return;
    }
    if (!dnisPattern.test(item.DNIS)) {
      this.lambdaError = true;
      this.lambdaMessage = 'invalid DNIS pattern'
      return;
    }
    if (item.QueueConfig.agentName == null || item.QueueConfig.agentName == "") {
      this.lambdaError = true;
      this.lambdaMessage = 'missing agent email'
      return;
    }
    if (item.QueueConfig.voiceMail == null || item.QueueConfig.voiceMail == "") {
      this.lambdaError = true;
      this.lambdaMessage = 'missing agent voicemail'
      return;
    }
    if (!this.validatePhone(item.QueueConfig.voiceMail)) {
      return;
    }

    this.formValid = true;
  }

  validatePhone(numString: any) {
    this.lambdaMessage = '';
    this.lambdaError = false;
    if (!(numString[0] == '+' && numString[1] == 1)) {
      this.lambdaError = true;
      this.lambdaMessage = "Missing '+1' at the beginning of phone number";
      return false;
    }
    //scrub input
    let test = numString;
    if (test.startsWith('+')) {
      test = test.slice(1, test.length);
    }
    test = test.split("-").join("");
    test = test.split("(").join("");
    test = test.split(")").join("");
    //is digital
    let reg = new RegExp('^[0-9]*$');
    if (!reg.test(test)) {
      this.lambdaError = true;
      this.lambdaMessage = 'Invalid phone number'
      return false;
    }
    //proper length and extension
    if (test.length < 11) {
      this.lambdaError = true;
      this.lambdaMessage = 'Number is too short'
      return false;
    }
    if (test.length > 11) {
      this.lambdaError = true;
      this.lambdaMessage = 'Number is too long'
      return false;
    }
    return true
  }

}
